import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "col"
}
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row pt-4" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = {
  key: 0,
  class: "row pt-4"
}
const _hoisted_7 = {
  key: 1,
  class: "col pt-4"
}
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "row gap-2" }
const _hoisted_12 = {
  type: "submit",
  class: "btn btn-primary col-3"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "add", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "delete", -1)
const _hoisted_15 = { class: "pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_i18n_input_text_editor = _resolveComponent("i18n-input-text-editor")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_AutoSaveFeedback = _resolveComponent("AutoSaveFeedback")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.pageUI.getError()
    }, null, 8, ["error"]),
    (_ctx.pageUI.getIsReady())
      ? (_openBlock(), _createBlock(_component_dp_form, {
          key: 0,
          as: "form",
          onSubmit: _ctx.saveProductLabel,
          novalidate: ""
        }, {
          default: _withCtx(({ errors }) => [
            (!_ctx.productLabel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('noProductLabelConfigured')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_i18n_input_text_editor, {
                      name: "content",
                      data: _ctx.productLabel.content,
                      "active-language": _ctx.activeLanguage,
                      errors: errors,
                      "show-language-indicator": "",
                      "null-when-empty": "",
                      label: _ctx.$t('label'),
                      mode: "basic",
                      height: 150,
                      "wrap-content-tag": '',
                      "onUpdate:data": _ctx.setHasUnsavedChanges
                    }, null, 8, ["data", "active-language", "errors", "label", "onUpdate:data"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_input_select, {
                      label: _ctx.$t('position'),
                      id: "position_code",
                      modelValue: _ctx.productLabel.position_code,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productLabel.position_code) = $event)),
                        _ctx.setHasUnsavedChanges
                      ],
                      name: "position_code",
                      options: _ctx.positionOptions,
                      errors: errors,
                      class: "col-4"
                    }, null, 8, ["label", "modelValue", "options", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_input_select, {
                      label: _ctx.$t('layout'),
                      id: "layout_code",
                      modelValue: _ctx.productLabel.layout_code,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productLabel.layout_code) = $event)),
                        _ctx.setHasUnsavedChanges
                      ],
                      name: "layout_code",
                      options: _ctx.layoutOptions,
                      errors: errors,
                      class: "col-4"
                    }, null, 8, ["label", "modelValue", "options", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", {
                    class: "bg-color-buttons btn-group btn-group-sm w-auto mt-3",
                    role: "group",
                    "aria-label": _ctx.$t('colorScheme')
                  }, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleOverwriteColorScheme())),
                      class: _normalizeClass(['btn btn-outline-primary', {'active': !_ctx.overwriteColorScheme}]),
                      type: "button"
                    }, _toDisplayString(_ctx.$t('cms.colorStandard')), 3),
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleOverwriteColorScheme())),
                      class: _normalizeClass(['btn btn-outline-primary', {'active': _ctx.overwriteColorScheme}]),
                      type: "button"
                    }, _toDisplayString(_ctx.$t('cms.colorCustom')), 3)
                  ], 8, _hoisted_5),
                  (!_ctx.overwriteColorScheme)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_input_select, {
                          id: "scheme_color_code",
                          label: _ctx.$t('colorScheme'),
                          modelValue: _ctx.productLabel.scheme_color_code,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => ((_ctx.productLabel.scheme_color_code) = $event)),
                            _ctx.setHasUnsavedChanges
                          ],
                          name: _ctx.$t('colorScheme'),
                          options: _ctx.colorSchemeOptions,
                          errors: errors,
                          class: "col-4"
                        }, null, 8, ["label", "modelValue", "name", "options", "errors", "onUpdate:modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.overwriteColorScheme)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_ColorPicker, {
                              modelValue: _ctx.productLabel.background_color,
                              "onUpdate:modelValue": [
                                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productLabel.background_color) = $event)),
                                _ctx.setHasUnsavedChanges
                              ],
                              label: _ctx.$t('background'),
                              name: "background_color",
                              label_bold: false
                            }, null, 8, ["modelValue", "label", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_ColorPicker, {
                              modelValue: _ctx.productLabel.text_color,
                              "onUpdate:modelValue": [
                                _cache[6] || (_cache[6] = ($event: any) => ((_ctx.productLabel.text_color) = $event)),
                                _ctx.setHasUnsavedChanges
                              ],
                              label: _ctx.$t('text'),
                              name: "background_color",
                              label_bold: false
                            }, null, 8, ["modelValue", "label", "onUpdate:modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", _hoisted_12, [
                      _hoisted_13,
                      _createTextVNode(_toDisplayString(_ctx.$t('save')), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-primary col-3",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.deleteProductLabel && _ctx.deleteProductLabel(...args)))
                    }, [
                      _hoisted_14,
                      _createTextVNode(_toDisplayString(_ctx.$t('delete')), 1)
                    ])
                  ])
                ])),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_AutoSaveFeedback, { status: _ctx.autoSaveFeedbackStatus }, null, 8, ["status"])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true)
  ], 64))
}